var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{
    'notifications-list-state': true,
    'notifications-list-state__small': _vm.size === 'small',
    'notifications-list-state__error': _vm.mode === 'error',
  }},[_c('div',{class:{
      'notifications-list-state__icon__wrapper': true,
      'notifications-list-state__icon__wrapper__background': !_vm.hideBackground,
    }},[_vm._t("default")],2),_c('transition-group',{staticClass:"notifications-list-state__text-wrapper",attrs:{"name":"text-slide","appear":""}},[(_vm.text)?_c('p',{key:'text',staticClass:"notifications-list-state__text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),(_vm.secondaryText)?_c('p',{key:'secondary-text',staticClass:"notifications-list-state__secondary-text"},[_vm._v(" "+_vm._s(_vm.secondaryText)+" ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }